import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { POS_ROUTES } from 'PointOfSale/modules/common/constants';

import 'PointOfSale/styles/components/pageFooter.less';
import { Icon, Button } from 'semantic-ui-react';

const MealsTypesFooter = props => {
  const { enableContinue } = props;
  const linkClass = classNames({
    link: true,
    'disabled-link': !enableContinue,
  });
  return (
    <span className="continue-action">
      <Link className={linkClass} to={POS_ROUTES.SERVE_OPTIONS}>
        <Button
          primary
          size="large"
          disabled={!enableContinue}
          className={'page-footer-button'}
        >
          <Button.Content>
            Continue <Icon name={'forward'} />
          </Button.Content>
        </Button>
      </Link>
    </span>
  );
};

export default MealsTypesFooter;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/MealsTypesFooter.js